import React, { Fragment } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

const TitledQuestion = ({ index, answer, handleOptionSelected }) => {
  const options = JSON.parse(answer.options);

  return (
    <Fragment>
      <h5 className='my-3'>
        {`${index}. `}
        {answer.title}
      </h5>
      <Row className='justify-content-center'>
        {options.map((o) => (
          <Col xs={12} md={7} key={o.index}>
            <Button
              block
              className='my-2'
              variant='outline-secondary'
              onClick={(e) => handleOptionSelected(e, o.index)}
            >
              {o.label}
            </Button>
          </Col>
        ))}
      </Row>
    </Fragment>
  );
};

export default TitledQuestion;
